export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553282098/ArafZamani/arafkapak.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553282098/ArafZamani/araf004.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553282098/ArafZamani/araf003.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553282099/ArafZamani/araf005.jpg'
];